export default "__VITE_ASSET__RIbi_VKe__"